const baseColors = {
  // Base grays
  Gray100: "#E8E9EA",
  Gray200: "#F4F4F4",
  Gray300: "#DDDDDD",
  Gray400: "#676A6D",
  Gray500: "#dbdee1",
  Gray600: "#727272",
  Gray700: "#5E5E5E",
  Gray800: "#3F3F3F",
  Gray900: "#1F1F1F",
  Gray400Alt: "#BABABA",

  // Base colors
  White: "#FFFFFF",
  Black: "#111C18",
  Transparent: "transparent",

  // Primary colors
  PrimaryGreen: "#25CB8E",
  PrimaryLightGreen: "#A3FCC2",
  PrimaryLightGreenBg: "#E7F8EC",

  // Status colors
  SuccessGreen: "#0CC44D",
  ErrorRed: "#F01120",
  WarningOrange: "#FA9313",
};

export const defaultPalette = {
  // primary colors
  Primary100: baseColors.PrimaryGreen, // primary color (buttons, indicators, link hover, etc.)
  Primary200: baseColors.PrimaryLightGreen, // menu item selected bg
  Primary300: baseColors.PrimaryLightGreenBg, // primary color (buttons, indicators, link hover, etc.)
  Primary400: baseColors.PrimaryLightGreenBg, // bid message bg (light blue)
  Primary500: baseColors.PrimaryLightGreen,

  //   basic colors
  Basic100: baseColors.Gray100, // inputs bg color, borders
  Basic200: baseColors.Gray200, // background color of table sorted column
  Basic300: baseColors.Gray300, // color of label, placeholder, message text, etc.
  Basic400: baseColors.Gray400, // status bar main text color, default button border color
  Basic500: baseColors.Gray500, // collapse border color
  Basic600: baseColors.Gray600, // border color, inputs hover border color
  Basic700: baseColors.Gray700, // bg color for grey radio buttons
  Basic800: baseColors.Gray800, // main color text
  Basic900: baseColors.Gray900,

  nBasic100: baseColors.Gray100, // inputs bg color, borders
  nBasic200: baseColors.Gray200, // background color of table sorted column
  nBasic300: baseColors.Gray300, // color of label, placeholder, message text, etc.
  nBasic400: baseColors.Gray400Alt, // status bar main text color, default button border color
  nBasic500: baseColors.Gray500, // collapse border color
  nBasic600: baseColors.Gray600, // border color, inputs hover border color
  nBasic700: baseColors.Gray700, // bg color for grey radio buttons
  nBasic800: baseColors.Gray800, // main color text
  nBasic900: baseColors.Gray900,

  // main colors
  Background: "#F3F4F5", // bg main page
  MenuBackground: "#EBECEE", // menu bg
  MenuText: baseColors.White,
  MenuTextSelected: baseColors.Black,
  MenuItemSelectedBg: baseColors.Gray200,
  HeaderText: baseColors.Gray200,
  HeaderTextSecondary: baseColors.Gray400Alt,
  UserText: baseColors.Gray200,
  UserTextSecondary: baseColors.Gray400Alt,
  HeaderBackground: baseColors.Gray900, // header bg
  HeaderBorder: baseColors.Gray800,
  White: baseColors.White, // white color
  Black: baseColors.Black, // black color
  Error: baseColors.ErrorRed, // error color
  Success: baseColors.SuccessGreen, // success color
  Warning: baseColors.WarningOrange, // warning color
  Attention300: "#FEEDD4", // attention color
  Gray2: "#F5F6F7", // input hover bg
  Gray4: "#0E0E0E0D", // light button hover bg
  Gray5: "#A0A3AA", // status bar secondary text color

  //uikit
  Purple: "#7527E3",
  Purple2: "#D8D4F9",
  Purple3: "#9221C2",

  // status colors
  Gray: "#818387", // status color
  Gray1: "#E2E5EB", // status bg
  Gray3: "#A0A3AA4D", // status border
  Blue: "#1A87FF", // color
  Blue1: "#D8EAFF", // bg
  Blue3: "#1A87FF4D", // border
  Blue8: "#0D3EEB", // primary
  Green: baseColors.SuccessGreen, // color
  Green1: "#D5F9DB", // bg
  Green3: "#0CC44D4D", // border
  Red: "#EC2D20", // color
  Red1: "#FFDEDA", // bg
  Red3: "#EC2D204D", // border

  Transparent: baseColors.Transparent,
};
